import React, {useMemo, useRef, useState} from "react";
import {useMount} from "react-use";
import Form, {FormInputComponent} from "../../../components/form/Form";
import {Badge, InputNumber, Statistic, Table} from "antd";
import {useTeamCandidateScope} from "./TeamCandidateScopeProvider";
import UserImageCircle from "../../../components/UserImageCircle";
import SpinLoader from "../../../components/SpinLoader";
import ReactDOM from "react-dom";
import LoadingSpinner from "../../../components/LoadingSpinner";

const TeamDeliverableForm = ({deliverable, onClose, onCancel, ...props}) => {

    const [editable, setEditable] = useState(false);

    const formRef = useRef(null);
    const [desiredLabel, desiredColor] = useMemo(() => {
        let color;
        let label;
        switch (deliverable.is_desired) {
            case true:
                color = TB.config('color.success-dark');
                label = 'Yes';
                break;
            case false:
                color = TB.config('color.danger-dark');
                label = 'No';
                break;
            case null:
                color = '#b7b7b7';
                label = 'Unsure';
                break;
        }
        return [label, color]
    }, [deliverable?.is_desired]);

    useMount(() => {
        setTimeout(() => {
            setEditable(true)
        }, 50)
    })

    const [formModel, setFormModel] = useState({
        ...deliverable,
    });

    const totalTeamHours = TB.sumBy(formModel.activities, activity => {
        return TB.sumBy(activity.disciplines, discipline => discipline.total_team_hours || 0)
    })

    const totalTeamCost = TB.sumBy(formModel.activities, activity => {
        return TB.sumBy(activity.disciplines, discipline => {
            if (discipline.talent_opp) {
                return discipline.talent_opp?.opp_discipline?.hourly_rate * (discipline.total_team_hours || 0)
            }
            return discipline.market_rate * (discipline.total_team_hours || 0)
        })
    })

    const {
        team,
        isLoading,
        isDisabled,
        updateDeliverableActivitiesForTeam,
        updateTeamScope
    } = useTeamCandidateScope();

    const onSubmit = async () => {

        let invalidFields = await formRef.current?.forceValidate();

        if (invalidFields) {
            const node = ReactDOM.findDOMNode(invalidFields);

            $('.ant-modal-wrap')?.animate({scrollTop: $(node).offset().top}, 1000);
        }
        let talent_users = await updateDeliverableActivitiesForTeam(formModel);

        let response = await updateTeamScope({talent_users});

        if (response) {
            return onClose()
        }
    }

    if (isLoading || !team) {
        return (
            <div className="flex flex-col items-center py-5">
                <LoadingSpinner size="lg"/>
            </div>
        )
    }

    return (
        <SpinLoader isLoading={isDisabled}>

                <div className="flex flex-col items-stretch">
                    <div className="pb-4 px-6">
                        <Form
                            ref={formRef}
                            minimal
                            submitButton={false}
                            background={"none"}
                            isDisabled={isDisabled}
                            model={formModel}
                            onChange={async (model) => {
                                let updatedFormModel = {...formModel};

                                for (let [key, value] of Object.entries(model)) {
                                    updatedFormModel = TB.set(updatedFormModel, key, value);
                                }

                                console.log('onchange', {totalTeamHours, totalTeamCost})
                                await setFormModel(updatedFormModel)
                                console.log({totalTeamHours, totalTeamCost})
                            }}
                            fields={[]}
                            onSubmit={null}
                        >
                        <div className="flex flex-col items-stretch">

                            <div
                                className="flex flex-row items-start gap-4 pb-2 border-b border-wripplePrimaryRuleBlue mb-4">

                                <div className="basis-3/5 flex flex-col gap-2">
                                    <p className="text-base font-semibold">
                                        Deliverable: {deliverable.name}
                                    </p>
                                    <p className="text-xs">
                                        {deliverable.description}
                                    </p>
                                </div>

                                <div className="basis-1/5 flex items-center justify-center">
                                    <Statistic title="Estimated Hours"
                                               value={`${totalTeamHours} hrs`}/>
                                </div>
                                <div className="basis-1/5 flex items-center justify-center">
                                    <Statistic title="Estimated Payout"
                                               value={TB.formatCurrency(totalTeamCost)}/>
                                </div>
                            </div>
                            <div
                                className="flex flex-row gap-4 pb-2 border-b border-wripplePrimaryRuleBlue mb-4 items-start">
                                <div className="basis-1/4 flex flex-row items-center gap-2">
                                    <p className="text-sm font-medium">
                                        Desired By Client:
                                    </p>
                                    <Badge count={desiredLabel} showZero color={desiredColor}/>
                                </div>
                                <div className="basis-1/4 flex flex-col items-start gap-2">
                                    <p className="text-sm font-medium">
                                        Client Provided Notes:
                                    </p>
                                    <div className="relative">
                                        <p className="text-xs line-clamp-3 overflow-ellipsis">{
                                            formModel.client_comments || (
                                                <i>No Addition Notes Provided</i>)}
                                        </p>
                                    </div>
                                </div>
                                <div className="basis-1/4 flex flex-col items-start gap-2">
                                    <p className="text-sm font-medium">
                                        Assumptions:
                                    </p>
                                    <div
                                        dangerouslySetInnerHTML={{__html: formModel.assumptions || '<i>Not provided</i>'}}></div>
                                </div>
                                <div className="basis-1/4 flex flex-col items-start gap-2">
                                    <p className="text-sm font-medium">
                                        Notes To Talent:
                                    </p>
                                    <div
                                        dangerouslySetInnerHTML={{__html: formModel.notes_to_talent || '<i>Not provided</i>'}}></div>
                                </div>

                            </div>
                            <div className="flex flex-col gap-4 pb-2 mb-4">
                                <p className="text-base font-semibold mb-3">
                                    Estimated Hours By Activity
                                </p>
                                <div className="flex-grow px-4 flex flex-col gap-4">
                                    {TB.map(formModel.activities, (activity, activityIndex) => (
                                        <div
                                            key={activity.id}
                                            className="flex flex-col items-stretch gap-6 pb-4 border-b border-wripplePrimaryRuleBlue mb-4">

                                            <div className="flex flex-col gap-1">
                                                <p className="text-sm font-medium text-secondary">
                                                    Activity #{activityIndex + 1}:
                                                </p>

                                                <div className="text-xs"
                                                     dangerouslySetInnerHTML={{
                                                         __html: activity.description || '<i>No Description Provided...</i>'
                                                     }}/>
                                            </div>
                                            <Table key={`act-${activity.id}`} size="small" pagination={false}
                                                   rowKey='id'
                                                   dataSource={activity.disciplines}
                                                   summary={data => {

                                                       // let oppActivityIds = TB.map(data, 'id')

                                                       // console.log('matchprojectddd', matchedProjectDisciplines)

                                                       return (
                                                           <Table.Summary.Row>
                                                               <Table.Summary.Cell index={0} className="bg-gray-50">

                                                               </Table.Summary.Cell>
                                                               <Table.Summary.Cell index={1} className="bg-gray-50">

                                                               </Table.Summary.Cell>
                                                               <Table.Summary.Cell index={2} className="bg-gray-50">
                                                                   <p className="font-semibold">
                                                                       Totals
                                                                   </p>
                                                               </Table.Summary.Cell>
                                                               <Table.Summary.Cell index={3} className="bg-gray-50">
                                                                   <p className="font-semibold">
                                                                       {TB.sumBy(activity.disciplines, act => act.total_hours || 0)} hours
                                                                   </p>
                                                               </Table.Summary.Cell>
                                                               <Table.Summary.Cell index={4} className="bg-gray-50">
                                                                   <p className="font-semibold">
                                                                       {totalTeamHours} hours
                                                                   </p>
                                                               </Table.Summary.Cell>
                                                               <Table.Summary.Cell index={5} className="bg-gray-50">
                                                                   <p className="font-semibold">
                                                                       {TB.formatCurrency(totalTeamCost)}
                                                                   </p>
                                                               </Table.Summary.Cell>
                                                           </Table.Summary.Row>
                                                       )
                                                   }}>


                                                <Table.Column title="Role" dataIndex="name" key="name"
                                                              render={(name) => (
                                                                  <p
                                                                      className="text-sm font-medium">
                                                                      {name || 'N/A'}
                                                                  </p>
                                                              )}/>
                                                <Table.Column title="Assigned Team Member" dataIndex="id" key="id"
                                                              render={(_, discipline) => {
                                                                  let matchedTeamDiscipline = TB.find(team.disciplines, ['id', discipline.id]);

                                                                  if (!matchedTeamDiscipline.talent_opp?.user) {
                                                                      return (
                                                                          <p className="italic text-gray">
                                                                              Member Not Assigned
                                                                          </p>
                                                                      )
                                                                  }
                                                                  return (
                                                                      <div className="flex flex-row items-center gap-2">
                                                                          <UserImageCircle
                                                                              user={matchedTeamDiscipline.talent_opp?.user}
                                                                              size={32}/>
                                                                          <p className="font-medium">
                                                                              {matchedTeamDiscipline.talent_opp?.user.fullName()}
                                                                          </p>
                                                                      </div>
                                                                  )
                                                              }}/>

                                                <Table.Column title="Rate" dataIndex="id" key="id"
                                                              render={(_, discipline) => {
                                                                  if (!discipline.talent_opp?.opp_discipline) {
                                                                      return (
                                                                          <p className="italic text-gray">
                                                                              -
                                                                          </p>
                                                                      )
                                                                  }
                                                                  const matchedDiscipline = discipline.talent_opp.opp_discipline;
                                                                  const rate = parseFloat((matchedDiscipline.proposed_hourly_rate || matchedDiscipline.hourly_rate))
                                                                  return (
                                                                      <p>
                                                                          {TB.formatCurrency(rate)}/hr
                                                                      </p>
                                                                  )
                                                              }}/>

                                                <Table.Column title="Original Scoped Hours" dataIndex="id" key="id"
                                                              render={(_, record) => {
                                                                  return (
                                                                      <p>
                                                                          {record?.total_hours ? `${record.total_hours} hours` : '-'}
                                                                      </p>
                                                                  )
                                                              }}/>

                                                <Table.Column
                                                    title="Hours" dataIndex="total_team_hours" key="total_team_hours"
                                                    render={(total_hours, discipline, index) => (
                                                        <div className="w-32">
                                                            <FormInputComponent
                                                                fieldName={`activities[${activityIndex}].disciplines[${index}].total_team_hours`}
                                                                value={discipline.total_team_hours || 0}
                                                                disabled={!discipline.talent_opp?.user}
                                                                required={true}
                                                                className="mb-0"
                                                                label={false}
                                                                type="antd-input">

                                                                <InputNumber
                                                                    controls={false}
                                                                    min={1}
                                                                    addonAfter="hrs"
                                                                    precision={0}
                                                                    defaultValue={discipline.total_team_hours || 0}/>

                                                            </FormInputComponent>
                                                        </div>
                                                    )}/>

                                                <Table.Column title="Est Payout" dataIndex="id" key="id"
                                                              render={(_, discipline) => {
                                                                  if (!discipline.talent_opp?.opp_discipline) {
                                                                      return (
                                                                          <p className="italic text-gray">
                                                                              -
                                                                          </p>
                                                                      )
                                                                  }
                                                                  const matchedDiscipline = discipline.talent_opp.opp_discipline;
                                                                  const cost = parseFloat((matchedDiscipline.proposed_hourly_rate || matchedDiscipline.hourly_rate)) * discipline.total_team_hours
                                                                  return (
                                                                      <p>
                                                                          {TB.formatCurrency(cost)}
                                                                      </p>
                                                                  )
                                                              }}/>
                                            </Table>
                                        </div>
                                    ))}
                                </div>


                            </div>
                        </div>

                        </Form>

                    </div>

                    <div className="flex flex-row items-center justify-end gap-4 px-6 py-4 border border-t-gray-300">

                        <button onClick={() => onCancel()} type="button" disabled={isDisabled}
                                className="btn btn-outline-dark">
                            Cancel
                        </button>

                        <button onClick={() => onSubmit()} className="btn btn-primary" disabled={isDisabled}>
                            Update
                        </button>
                    </div>

                </div>

        </SpinLoader>
    )
}
export default TeamDeliverableForm